/* © NXAPP Limited */
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

// In dev without .env, fall back to placeholders so the UI renders (auth will fail gracefully)
const url = supabaseUrl || 'https://placeholder.supabase.co'
const key = supabaseAnonKey || 'placeholder-key'

export const supabase = createClient(url, key, {
  auth: {
    autoRefreshToken: true,      // f1: auto-refresh tokens
    persistSession: true,
    detectSessionInUrl: true,
  },
})
